import { ApolloError } from '@apollo/client';
import { FC, ReactNode, useState } from 'react';

import ErrorMessage from 'components/ErrorMessage';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';

// Description: A button that opens a confirmation dialog before executing the action

const ConfirmButton: FC<{
  children: string | JSX.Element;
  onConfirm: any;
  loading?: boolean;
  error?: ApolloError;
  title?: string;
  description?: string;
  descriptionComponent?: ReactNode;
  confirmButtonLabel?: string;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  className?: string;
}> = ({
  children,
  onConfirm,
  loading,
  error,
  title,
  description,
  descriptionComponent,
  confirmButtonLabel,
  disabled,
  variant = 'primary',
  className,
}) => {
  const [showConfirmDialog, toggleConfirmDialog] = useState(false);

  return (
    <>
      <Button
        className={className}
        variant={variant}
        onClick={() => toggleConfirmDialog(true)}
        disabled={disabled}
      >
        {children}
      </Button>
      <Dialog
        open={showConfirmDialog}
        onClose={() => toggleConfirmDialog(false)}
        zIndexPriority="highest"
      >
        <DialogPanel>
          <DialogTitle>{title || 'Are you sure?'}</DialogTitle>
          {description && <p>{description}</p>}
          {descriptionComponent && descriptionComponent}
          {error && <ErrorMessage error={error} type="alert" />}
          <DialogActions>
            <Button variant="secondary" onClick={() => toggleConfirmDialog(false)}>
              Cancel
            </Button>
            <Button
              loading={loading}
              onClick={() => {
                onConfirm();
                toggleConfirmDialog(false);
              }}
            >
              {confirmButtonLabel || 'Confirm'}
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default ConfirmButton;
